import React, { Component } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

class Selection extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        toggleSelection: PropTypes.func.isRequired,
        isSelectionToolActive: PropTypes.bool.isRequired,
    }

    constructor(props)
    {
        super(props)

        this.mainField = React.createRef()
    }

    render()
    {
        const { t } = this.props

        return (
            <div>
                {t('visualizer:toolbar.left.collaborativeIndexationCreation.form.common.steps.selectZone.title')}

                <div className={'selection'}>
                    <button
                        className={classNames(
                            'btn',
                            'tertiary',
                            {'active': this.props.isSelectionToolActive},
                        )}
                        type={'button'}
                        title={t('visualizer:toolbar.left.collaborativeIndexationCreation.form.common.steps.selectZone.button')}
                        onClick={this.props.toggleSelection}
                    >
                        <i className={'nf nf-zone'} aria-hidden="true"></i>
                        <span className={'sr-only'}>{t('visualizer:toolbar.left.collaborativeIndexationCreation.form.common.steps.selectZone.button')}</span>
                    </button>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Selection)
